import { render, staticRenderFns } from "./DoubleAuth.vue?vue&type=template&id=25d11628"
import script from "./DoubleAuth.vue?vue&type=script&lang=js"
export * from "./DoubleAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports